<template>
  <transition name="page" mode="out-in">
    <component :is="layout" v-if="layout">
      <router-view />
    </component>
  </transition>
</template>

<script>
import AdminLayout from "./layouts/web/AdminLayout";
import AuthorizationLayout from "./layouts/web/AuthorizationLayout";

export default {
  name: "App",
  components: {
    AdminLayout,
    AuthorizationLayout
  },
  data() {
    return {
      layout: null,
      defaultLayout: "admin-layout",
    };
  },
  methods: {
    setLayout(route) {
      if (typeof route == "undefined" || this.layout != null) {
        this.layout = this.defaultLayout;
        document.body.classList.add(this.layout);
      } else {
        this.layout = route;
        document.body.classList.add(this.layout);
      }

    },
  },
  created() {
    this.setLayout(this.$setLayout.meta.layout);
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue